import styled from "styled-components"
import Img from "gatsby-image"
import media from "src/styles/media"

export const NavbarWrapper = styled.aside`
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  padding: 30px 40px;
  width: 100%;
  transition: all 0.4s ease-in-out;

  ${media.lessThan("md")`
        padding: 20px 0;
        opacity: 1 !important;
    `}

  ${props =>
    props.isSticky &&
    `
        opacity: 1;
        background-color: var(--dark);
        padding: 15px 0;
    `}
`

export const NavbarContent = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const NavbarAvatar = styled(Img)`
  z-index: 10;
  width: 150px;
  object-fit: contain;
  z-index: 12;
  cursor: pointer;
  transition: width 0.4s;

  @media screen and (min-width: 768px) and (max-width: 1020px) {
    width: 100px;
  }

  ${media.lessThan("md")`
       width: 130px;

       ${props =>
         props.isSticky &&
         `
            width: 90px;
        `}
    `}

  ${props =>
    props.isSticky &&
    `
        width: 120px;
    `}

  img {
    object-fit: contain !important;
  }
`

export const NavbarNav = styled.nav`
  z-index: 10;
  display: flex;
  align-items: center;

  ${media.lessThan("md")`
        align-items: flex-start;
        flex-direction: column;
        position: fixed;
        left: -200%;
        top: 0;
        transition: all 0.4s;
        background-color: rgba(20, 7, 58, 0.9);
        height: 100vh;
        width: 86vw;
        overflow-x: hidden;
        box-shadow: 4px 5px 20px rgba(0, 0, 0, .5);
        padding: 100px 10px 0 10%;
        opacity: 0;

        ${props =>
          props.isToggled &&
          `
            opacity: 1;
            left: 0;
        `}
   `}

  ${media.lessThan("sm")`
      padding-left: 7%;
   `}
`

export const NavbarNavList = styled.ul`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;

  ${media.lessThan("md")`
        flex-direction: column;
        align-items: flex-start;
   `}
`

export const NavbarToggler = styled.button`
  position: relative;
  display: none;
  justify-content: center;
  align-items: center;
  background: none;
  height: 30px;
  width: 30px;
  border: none;
  margin-right: -3px;

  &:focus {
    outline: none;
  }

  ${media.lessThan("md")`
        display: flex;
    `}

  .show {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    opacity: ${props => (props.isToggled ? 0 : 1)};

    span {
      display: block;
      width: 25px;
      height: 2px;
      border-radius: 1px;
      background: var(--white);
      margin-bottom: 2px;
    }

    span + span {
      margin-top: 4px;
      width: 20px;
    }
  }

  .close {
    opacity: ${props => (props.isToggled ? 1 : 0)};

    svg {
      width: 100%;
      height: 100%;
    }
  }

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
`

export const NavbarNavSocialWrapper = styled.div`
  display: none;
  color: #fff;
  font-weight: 300;
  font-size: 11px;
  padding-top: 26px;

  ${media.lessThan("md")`
        display: block;
    `}
`

export const NavbarNavSocialList = styled.ul`
  display: flex;
  align-items: center;
  background: none;
  padding: 0;
  margin-top: 15px;
`

export const NavbarNavSocialItem = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  height: 24px;
  width: 24px;
  color: #fff;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const Backdrop = styled.aside`
  z-index: 8;
  position: absolute;
  top: 0;
  left: 0;
  display: ${props => (props.show ? `block` : `none`)};
  height: 100vh;
  width: 100vw;
  background-color: black;
  opacity: 0.2;
`

export const LanguageButton = styled.button`
  background: none;
  background-color: none;
  border: none;
  padding: 0;
`
